import { MdKeyboardArrowLeft } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { IconButton } from '../../../components'
import {
  Breadcrumbs,
  PageContent,
  PageHeader
} from '../../../layout/components'
import { DebtsReportForm } from './components/Form'
import { DebtsProvider } from './context/debtsReport.context'

export const DebtsReport = () => {
  const navigation = useNavigate()
  return (
    <div>
      <PageHeader>
        <div
          style={{
            fontSize: 22,
            fontWeight: 800,
            marginBottom: '.5rem',
            height: 40,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <IconButton
            onClick={() => navigation('/reports')}
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <MdKeyboardArrowLeft
              size={24}
              color="#565656"
              style={{ background: '' }}
            />
          </IconButton>
          <div style={{ marginLeft: '1rem', fontSize: 22, fontWeight: 800 }}>
            Relatório de Inadimplências
          </div>
        </div>
        <Breadcrumbs
          links={[{ url: 'reports', name: 'Relatórios' }]}
          span="Relatório de Inadimplências"
        ></Breadcrumbs>
      </PageHeader>
      <PageContent>
        <DebtsReportForm />
      </PageContent>
    </div>
  )
}

export const DebtsReportPage = () => (
  <DebtsProvider>
    <DebtsReport />
  </DebtsProvider>
)

export default DebtsReportPage
